import * as React from "react";

import QuizButton from "./QuizButton";
import QuizAjaxButton from "./QuizAjaxButton";
import TodoButton from "./TodoButton";

export type TFinishCardContentProps = {
  quizUrl?: string | null;
  quizQuestionCount?: number | null;
  todoUrl?: string | null;
  todoAction?: string | null;
  caseSummaryUrl: string;
  title: string;
  timeOnCase?: string | null;
  // Optionally allow custom handlers for analytics/localStorage
  onSummaryClick?: () => void;
  showQuizImage?: boolean;
  showQuestionIcon?: boolean;
  showSummaryIcon?: boolean;
  showWellDoneText?: boolean;
  forModal?: boolean;
};

const FinishCardContent = ({
  quizUrl,
  quizQuestionCount,
  todoUrl,
  todoAction,
  caseSummaryUrl,
  title,
  timeOnCase,
  onSummaryClick,
  showQuizImage = false,
  showQuestionIcon = false,
  showSummaryIcon = false,
  showWellDoneText = false,
  forModal = false,
}: TFinishCardContentProps) => (
  <div className="finish-card-layout">
    {showWellDoneText && (
      <h4 className="finish-card-start">Well done! You have completed the case.</h4>
    )}
    {quizUrl && (
      <div className="finish-card-quiz-body">
        <div className="finish-card-body">
          <h2
            className="finish-card-heading"
            id={forModal ? "finish_card_heading" : undefined}
          >
            Next: Check your knowledge
          </h2>
          {showQuestionIcon && (
            <div className="finish-card-question-icon"></div>
          )}
          <p
            className="finish-card-content"
            id={forModal ? "finish_card_body" : undefined}
          >
            Take a PracticeSmart quiz with {quizQuestionCount} questions related
            to this case.
          </p>
          <p className="finish-card-content">
            <b> Short on time? </b> Save the quiz to your to-do list for later.
          </p>
        </div>
        <div className="quiz-buttons">
          {quizUrl.includes("create_start_quiz") ? (
            <QuizButton quizUrl={quizUrl.toString()} />
          ) : (
            <QuizAjaxButton
              quizUrl={quizUrl.toString()}
              onQuizLoaded={() => {}}
              caseName={title}
              timeOnCase={timeOnCase?.toString()}
            />
          )}
          {todoUrl && (
            <TodoButton
              todoUrl={todoUrl.toString()}
              todoAction={todoAction?.toString()}
              caseName={title}
              timeOnCase={timeOnCase?.toString()}
            />
          )}
        </div>
      </div>
    )}
    <div className="finish-card-summary-body">
      <h5
        className="finish-card-heading"
        id={forModal && !quizUrl ? "finish_card_heading" : undefined}
      >
        ACCESS CASE SUMMARY
      </h5>
      {showSummaryIcon && <div className="finish-card-summary-icon"></div>}
      <p
        className="finish-card-content"
        id={forModal && !quizUrl ? "finish_card_body" : undefined}
      >
        Download a printable Case Summary of the key teaching points covered in
        this case.
      </p>
    </div>
    <a
      className="finish-card-summary-button"
      href={caseSummaryUrl.toString()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="View case summary (opens in a new tab)"
      autoFocus
      onClick={onSummaryClick}
    >
      View Case Summary <span className="view-summary-icon"></span>
    </a>
  </div>
);

export default React.memo(FinishCardContent);
